<template>
  <div class="Dataset-container">
    <TopBar activeColor="#fff" :imgsrc="logo2" />
    <div class="Bigimg">
      <div class="Bigimg-container">
        <div class="selectBox">
          <input
            class="selectinp"
            placeholder="请输入数据资源关键字"
            type="text"
            v-model="keyword"
          />
          <div class="select-btn" @click="handleselct">
            <i class="iconfont icon-sousuo"></i>
            <p >搜索一下</p>
          </div>
        </div>
        <div class="label-list">
          <ul>
            <li :class="[index===data[2].i?'liActive':'']" v-for="(it, index) in data[2].list" :key="index" @click="handlebtn(index,2,$event)">{{it}}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="Dataset-content">
      <div class="left-select-box">
        <div class="select-terms" >
         
          <div class="term-body">
             <div class="term-head">
            <img :src="data[1].icon" alt="">
            <p>{{ data[1].title+':'}}</p>
          </div>
            <span :class="[j===data[1].i ? 'spanActive':'']" v-for="(it, j) in data[1].list" :key="j" @click="handlebtn(j,1,$event)">
              {{ it }}
            </span>
          </div>
        </div>
      </div>
      <div class="rigth-content-box" v-loading="isloading">
        <div class="Dataset-box">
          <div class="dataset-head">
            <p>数据资源样例</p>
            <div class="options">
              <select name="" id="">
                <option value="">智能推荐</option>
              </select>
            </div>
          </div>
          <div class="dataset-items" v-if="list" >
         <el-empty description="暂无数据" v-if="list.datasets===null"></el-empty>
            <div 
              class="dataset-item"
              @click="handleclick(item)"
              v-for="(item, index) in list.datasets"
              :key="index"
            >
              <div class="itembody">
                <div class="itembody-img">
                  <img :src="imgSrc(item)" alt="" />
                </div>
                <div class="itembody-text">
                  <p class="title">{{ item.name }}</p>
                  <div class="spanlist">
                    <span v-for="(it, i) in item.tags" :key="i">{{ it }}</span>
                    <span>{{setType(item)}}</span>
                  </div>
                  <p class="content">{{ item.profile }}</p>
                </div>
              </div>
              <div class="itembottom">
              <div class="iconlist">
                  <!-- <div class="look meta">
                  <i class="iconfont icon-wenjiandaxiao"></i>
                  <p>{{bytesToSize(item.size)}}</p>
                </div> -->
                <div class="look2 meta">
                  <i class="iconfont icon-chakan2"></i>
                  <p>{{item.view_num}}</p>
                </div>
                <div class="download meta">
                  <i class="iconfont icon-xiazai"></i>
                  <p>0</p>
                </div>
                <div class="Date meta">
                  <i class="iconfont icon-shijian"></i>
                  <p>{{formatDate(item.create_time)}}</p>
                </div>
              </div>

                <div class="logo">
                  <!-- <img :src="logo1" alt="" /> -->
                </div>
              </div>
            </div>
          </div>
          <div class="datasets-bottom" v-if="list">
            <el-pagination
              class="page"
              @current-change="setpager"
              @size-change="setPageSize"
              :current-page.sync="currentPage"
              :page-sizes="[9, 18]"
              :page-size="pageSize"
              layout="total, prev, pager, next, sizes,jumper"
              :total="list.total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon1 from "@/assets1/数据集页面_slices/编组 8@2x.png";
import icon2 from "@/assets1/数据集页面_slices/编组 8@2x(1).png";
import icon3 from "@/assets1/数据集页面_slices/编组 8@2x(2).png";
import logo2 from "@/assets1/logo_slices/编组 2.png"
import logo1 from "@/assets1/数据集页面_slices/导航栏-logo.png";
import img from "@/assets1/首页_slices (1)/编组 5.png";
import {addViewNum} from "@/api/Dataset"
import {bytesToSize} from "@/utils/Size"
import {formatDate} from "@/utils/Date"
import { selectDataset,DelDataset } from "@/api/Dataset";
import TopBar from "../supermarket/TopBar";
export default {
  components: {
    TopBar,
  },
  async created() {
    this.isloading=true

   await this.setDataset();
  //  await DelDataset(27)
   this.isloading=false
   
  },
  data() {
    return {
      logo2,
    isloading:true,
      icon1,
      icon2,
      icon3,
      dataMinSize:0,
      dataMaxSize:0,
      data_types:null,
      tags:null,
      list: null,
      currentPage: 1,
      pageSize:9,
      keyword: "",
      img,
      logo1,
      // listSize:0,
      // listtags:0,
      // listType:0,
      // src:'https://sxdatasets.oss-cn-chengdu.aliyuncs.com/1/test_cover_object',
      label: [{ title: "标签名" }],
      data: [
        {
          title: "数据资源大小",
           icon: icon1,
           i:0,
          list: [
            "全部",
            "<100KB",
            "100KB-1MB",
            "1MB-100MB",
            "100MB-1GB",
            "1GB-1TB",
            ">1TB",
          ],
        },
        {
          title: "数据类型",
              i:0,
          icon: icon2,
          list: ["全部", "文本", "图像", "音频", "视频", "点云"],
        },
        {
          title: "主题分类",
           icon: icon3,
           i:0,
          list: [
            "全部分类",
            "工业制造",
            "交通运输",
            "金融服务",
            "科技创新",
            "绿色低碳",
            "气象服务",
            "商贸流通",
            "文化旅游",
            "现代农业",
            "医疗健康",
            "应急管理",
            "城市治理",
          ],
        },
      ],
    };
  },
  methods: {
    handlebtn(it,i,e){
      this.data[i].i=it
      if(i===0){
        if(e.target.innerText==='全部'){
          this.dataMinSize=0
          this.dataMaxSize=0
        }else if(e.target.innerText==='<100KB'){
          this.dataMinSize=1
          this.dataMaxSize=100*1024
        }else if(e.target.innerText==='100KB-1MB'){
           this.dataMinSize=100*1024
           this.dataMaxSize=1024*1024
        }else if(e.target.innerText==='1MB-100MB'){
           this.dataMinSize=1024*1024
           this.dataMaxSize=1024*1024*100
        }else if(e.target.innerText==='100MB-1GB'){
           this.dataMinSize=1024*1024*100
           this.dataMaxSize=1024*1024*1024
        }else if(e.target.innerText==='1GB-1TB'){
           this.dataMinSize=1024*1024*1024
           this.dataMaxSize=1024*1024*1024*1024
        }else if(e.target.innerText==='>1TB'){
           this.dataMinSize=1024*1024*1024*1024
           this.dataMaxSize=0
        }
        this.setDataset()
        return
      }
      if(i===1){
        if(e.target.innerText==='全部'){
          this.data_types=null
        }else if(e.target.innerText==='文本'){
          this.data_types=['Text','JSON','EXCEL','CSV']
        }else if(e.target.innerText==='图像'){
          this.data_types=['Image']
        }else if(e.target.innerText==='音频'){
          this.data_types=['Audio']
        }else if(e.target.innerText==='视频'){
          this.data_types=['Video']
        }else if(e.target.innerText==='点云'){
          this.data_types=['click']
        }
        this.setDataset()
        return
      }
      if(i===2){
        if(e.target.innerText==='全部分类'){
          this.tags=null
        }else{
          this.tags=[e.target.innerText]

        }
          this.setDataset()
        return
      }
    },
    formatDate,
    async handleselct() {
        this.currentPage=1
        this.isloading=true
      await this.setDataset();

       this.isloading=false
      // this.keyword=''
    },

   async setPageSize(i) {
      this.pageSize = i;
      this.isloading=true
    await  this.setDataset();
       this.isloading=false
      //   this.getDataset()
    },
   async setpager(i) {
      this.currentPage = i;
      this.isloading=true
    await  this.setDataset();
    this.isloading=false
    },
   async handleclick(item) {
      // await addViewNum(item.id)
      // console.log(item);
      
      this.$router.push({
        path: `/DatasetItem`,
        query:{
          list:item
        }
      });
    },
    async setDataset() {
      this.list = await selectDataset({
        page_no: this.currentPage,
        page_size: this.pageSize,
        keyword: this.keyword,
        max_size:this.dataMaxSize,
        min_size:this.dataMinSize,
        data_types:this.data_types,
        tags:this.tags,

      });
    },
  
    imgSrc(it){
      return `https://${it.cover_bucket
}.oss-cn-chengdu.aliyuncs.com/${it.cover_object}`


    },
   bytesToSize,
   setType(it){
if(it.status===1){
  return `公开数据资源`
}
    
   }
  },
  computed: {
  
  },
};
</script>

<style scoped>
.el-empty{
  width: 100%;
}
.icon-wenjiandaxiao{
  margin-top: -1.5px;
  font-size: 12px;
}
.iconlist{
  padding-right: 20px;
  width: 368px;
  display: flex;
}
.Dataset-box {
}
::v-deep .el-pagination__total {
  margin-right: 20px;
}
::v-deep .el-pagination__jump {
  margin-left: 17px;
}
::v-deep .btn-next {
  margin-top: 0.5px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
 width: 28px;
  height: 28px;
  line-height: normal;
  padding: 0;
  margin-right: 14px;
  /* margin-right: 8px; */
}
::v-deep .btn-prev {
  margin-top: 0.5px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
width: 28px;
  height: 28px;
  line-height: normal;
  padding: 0;
  margin-right: 8px;
}
.datasets-bottom .el-pagination {
  font-size: 12px;
  font-family: Regular;
  color: fff;
}
::v-deep .datasets-bottom .el-pager .number {
  font-size: 12px;
  font-family: Light;
  border-radius: 4px;
  border: 1px solid #d9d9d9;

  padding: 5px 11px;
}
::v-deep .datasets-bottom .el-pager .active {
  color: #fff;
  background-color: #0d53ff;
}
::v-deep .datasets-bottom .el-pager li {
  margin-right: 8px;
width: auto;
  height: auto;
  line-height: normal;
  color: #666;
}
.datasets-bottom {
  position: absolute;
  bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.logo {
  width: 58px;
  height: 14px;
  object-fit: cover;
}
.logo img {
  width: 100%;
  height: 100%;
  display: block;
}
.itembottom {
  margin-top: 12px;

  display: flex;
  padding-left: 5px;
}
.meta  i.iconfont {
  /* display: block; */
  margin-right: 4px;
}
.itembottom .meta:last-child {
  margin-right: 0;
}
.meta {

  font-size: 12px;
  color: #999;
display: flex;
align-items: center;
height: 16px;
line-height: 16px;
  /* justify-content: center; */
  margin-right: 25px;
}
.meta p {

}
.meta>.iconfont{
  height: 16px;
  line-height: normal;
  /* margin: auto; */
 font-size: 15px;
  /* background-color: #000; */
  padding-right: 4px;


}
.meta>.icon-chakan2::before{
  margin-top: 1px;
height: 16px;
line-height: 16px;
display: block;

}

.content {
  color: #838690;
  font-size: 14px;
  line-height: 20px;
  font-family: Regular;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.spanlist span {
  background-color: rgba(13, 83, 255, 0.1);
  padding: 2px 8px;
  font-size: 12px;
  margin-right: 4px;
  color: #0d53ff;
  font-family: Regular;
}
.spanlist {
  margin-bottom: 13px;
}
.title {
  font-size: 16px;
  font-family: Medium;
  white-space: nowrap;
overflow: hidden;
  font-size: 16px;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  width: 240px;
}
.itembody {
  display: flex;
}
.itembody-img {
  margin-right: 16px;
}
.itembody-img img {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
.dataset-items {
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-evenly; */
  margin-bottom: 80px;
}
.dataset-item {
  border-radius: 8px;
  border: 1px solid #eee;
  margin-left: 10px;
  width: 442px;
  height: 157px;
  margin-bottom: 12px;
  padding-top: 16px;
  cursor: pointer;
  padding-left: 16px;
  padding-right: 16px;
}
.dataset-head {
  display: flex;
  margin-top: 24px;
  font-size: 24px;
  margin-bottom: 24px;
  justify-content: space-between;
  font-family: Medium;
}
.dataset-head p{
  margin-left: 10px;
}
.options {
  margin-left: 666px;
  width: 100px;
  height: 32px;
  background-color: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: center;
}
select {
  border: none;
  outline: none;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  font-family: Regular;
  color: #838690;
  background-color: transparent;
}
.select-terms {
  margin-bottom: 10px;
}
.select-terms:last-child {
  margin-bottom: 0px;
}
.iconfont {
  margin-right: 12px;
  line-height: 22px;
}
.term-head {
  display: flex;
  margin-bottom: 10px;
  font-size: 16px;
  font-family: Medium;
  margin-right: 15px;
}
.term-head img{
    width: 26px;
    height: 26px;
    margin-right: 8px;
}
.term-head p {
  line-height: 26px;
}
.term-body {
  font-family: Regular;

  /* width: 186px; */
  /* height: 112px; */
  font-size: 14px;
  display: flex;
  color: #666;
  flex-wrap: wrap;
}
.term-body span {


  margin-right: 14px;
  margin-bottom: 10px;
  display: inline-block;
cursor: pointer;
  padding: 2px 5px;
}
.spanActive{
    background-color: rgba(13, 83, 255 ,.1);
    color: #0d53ff;
}
.rigth-content-box {
  padding: 0 24px 0 14px;
  width: 1400px;
  /* height: 665px; */
  background-color: #fff;
  border-radius: 12px;
  position: relative;
}
.left-select-box {
  padding: 36px 20px 20px 20px;
  /* width: 240px; */
  /* min-height: 665px; */
  width: 1400px;
  background-color: #fff;
  border-radius: 12px;
  /* margin-right: 16px; */
  margin-bottom: 30px;
}
.Dataset-content {
  width: 100%;
height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
  padding: 16px 360px 39px 360px;
  background-color: #f7f8fc;
}
.label-list ul {
  justify-content: space-evenly;
  display: flex;
  flex-wrap: wrap;
}
.label-list ul li {
padding: 8px 12px;
  text-align: center;
  background-color: greenyellow;
  font-size: 14px;
  font-family: Regular;
  margin-right: 8px;
  border-radius: 4px;
   background-color: #0d53ff;
   cursor: pointer;
   margin-bottom: 8px;
}
.label-list ul li.liActive{
  background-color: #fff;
  color: #0d53ff;
}
/* .label-list ul li:nth-child(1) {
  background-color: #0d53ff;
}
.label-list ul li:nth-child(2) {
  background-color: #00c602;
}
.label-list ul li:nth-child(3) {
  background-color: #ff7a17;
}
.label-list ul li:nth-child(4) {
  background-color: #ffd000;
} */
.label-list {
   width: 1192px;
  margin-top:25px;
  color: #fff;
  font-family: Regular;
}

.Dataset-container {
  min-width: 1920px;
  position: relative;
}
.Bigimg {
  width: 100%;
  background-image: url('https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E6%8D%AE%E9%9B%86%E9%A1%B5%E9%9D%A2/%E4%BD%8D%E5%9B%BE.png');
  background-size: cover;
  height: 360px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.selectinp {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 5px;
  width: 800px;
  height: 50px;
  font-size: 16px;
  font-family: Regular;
  outline: none;
  border: none;
  padding-left: 5px;
}
.selectBox {
  width: 1192px;
  height: 60px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 0 0 5px rgba(204, 204, 204, 0.8);
  position: relative;
}
.select-btn {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  width: 160px;
  height: 52px;
  border-radius: 3px;
  background-color: #0d53ff;
  color: #fff;
  font-family: Regular;
  font-size: 18px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.icon-sousuo {
  font-size: 23px;
  margin-right: 11px;
}
</style>